
import SearchList from "./components/SearchList.tsx";
import { usePageTitle } from './hooks/usePageTitle';

function TerraStationFliers() {
  usePageTitle('Fliers')
  return (
    <div
      id="ts-terrastation-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-terrastation-content"
        className="w-full xl:max-w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          TerraStation Fliers
        </div>

        <SearchList reqURL='/api/list/fliers'/>
      </div>
    </div>
  );
}

export default TerraStationFliers;
